import { secondaryMarketKycActionsFactory } from 'state/secondaryMarket/shared/kyc/kyc.action';

export const cpOrderKycActions = secondaryMarketKycActionsFactory<'CP_ORDER'>('CP_ORDER');
type TypeofCpOrderKycActions = typeof cpOrderKycActions;
export type SecondaryMarketCpOrderKycStatusFailed = ReturnType<
  TypeofCpOrderKycActions['secondaryMarketKycStatusFailed']
>;
export type SecondaryMarketCpOrderKycStatusReceived = ReturnType<
  TypeofCpOrderKycActions['secondaryMarketKycStatusReceived']
>;
export type SecondaryMarketCpOrderKycStatusRequested = ReturnType<
  TypeofCpOrderKycActions['secondaryMarketKycStatusRequested']
>;
export type SecondaryMarketCpOrderKycStatusReset = ReturnType<TypeofCpOrderKycActions['secondaryMarketKycStatusReset']>;

export type SecondaryMarketCpOrderKycStatusActions = ReturnType<TypeofCpOrderKycActions[keyof TypeofCpOrderKycActions]>;
